import React, { useEffect } from 'react';
import type { SingleCommonType } from '../../types';
import { commonBackInfo } from '../../utils';
import { UVPMPlaceholder } from '../../constants/placeholder';
import CustomFollowerRange from '../../components/CustomFollowerRange';
import { useSetRangeDefaultValue } from '../../hooks/init';
import { useIntl } from 'umi';
import './index.scss';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';

export default function NewsUVPMSelect({
  onChange,
  defaultValue,
  filterValue,
  defaultKey,
  oriDefaultFilter,
  backOriDefaultValue,
  lang,
}: SingleCommonType) {
  const { formatMessage } = useIntl();

  const { rangeValue, setRangeValue, followerRef, options, diffClassName } =
    useSetRangeDefaultValue({
      defaultValue,
      filterValue,
      defaultKey: 'uvpm',
      oriDefaultFilter,
      backOriDefaultValue,
      options: [
        { text: 'All', value: '-' },
        { text: '0 ~ 1000', value: '0-1' },
        { text: '1000 ~ 5000', value: '1-5' },
        { text: '5000 ~ 10000', value: '5-10' },
        { text: '> 10000', value: '10-' },
      ],
    });
  useEffect(() => {
    const showHeader = followerRef.current?.buttonElement?.(rangeValue);
    const data = [];
    if (rangeValue !== '-') {
      const [start_uvpm, end_uvpm] = rangeValue.split('-');
      let dataItem: { start_uvpm: number; end_uvpm?: number } = {
        start_uvpm: Number(start_uvpm) * 1000,
      };
      if (end_uvpm !== '') {
        dataItem['end_uvpm'] = Number(end_uvpm) * 1000;
      }
      data.push(dataItem);
    }

    onChange?.(
      'newsUVPM',
      commonBackInfo({ uvpm: data }, { newsUVPM: showHeader }),
    );
  }, [rangeValue, formatMessage]);

  return (
    <div className={`dbo-engagement-range-wrapper ${diffClassName}`}>
      <CustomFollowerRange
        lang={lang}
        ref={followerRef}
        options={options}
        setRangeValue={setRangeValue}
        rangeValue={rangeValue}
        pointKey={FilterButtonPoint.newsUVPM}
        placeholder={UVPMPlaceholder}
      ></CustomFollowerRange>
    </div>
  );
}
